import { dateProvider } from '@utils';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { TaskLogItem } from './TaskLogItem';
import { ColumnWrapper, Wrapper, TitleWrapper } from './TaskLogsModal.styles';

import { TaskStatusBadge } from '@/components/TaskStatusBadge';
import { useTaskLogsModal } from '@/store';

const TASK_LOGS_MODAL_WIDTH = 600;

export const TaskLogsModal = () => {
  const { t } = useTranslation('CourseTranslations');
  const { logs, setLogs } = useTaskLogsModal();

  if (!logs) return null;

  return (
    <Modal
      open
      centered
      footer={null}
      title={t('STATUS_HISTORY')}
      width={TASK_LOGS_MODAL_WIDTH}
      onCancel={() => setLogs()}>
      <Wrapper>
        <ColumnWrapper>
          <TitleWrapper>{t('STATUS')}</TitleWrapper>
          {logs.map((log, index) => (
            <TaskStatusBadge key={`status-${index}`} status={log.status} />
          ))}
        </ColumnWrapper>
        <ColumnWrapper>
          <TitleWrapper>{t('DATE')}</TitleWrapper>
          {logs.map((log, index) => (
            <div key={`date-${index}`}>{dateProvider.format(log.date, 'dd/MM/yyyy - hh:mm a')}</div>
          ))}
        </ColumnWrapper>
        <ColumnWrapper>
          <TitleWrapper>{t('CHANGED_BY')}</TitleWrapper>
          {logs.map((log, index) => (
            <TaskLogItem key={`changed-by-${index}`} log={log} />
          ))}
        </ColumnWrapper>
      </Wrapper>
    </Modal>
  );
};
